import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../components/toaster/toaster.model';

@Component({
  selector: 'copy-element',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './copy-element.component.html',
  styleUrl: './copy-element.component.scss',
})
export class CopyElementComponent {
  @Input() html!: HTMLElement | string;

  constructor(private tooaster: ToasterService) {}

  copy() {
    const outerHTML =
      this.html instanceof HTMLElement
        ? this.html?.outerHTML?.replace(/\s_ngcontent[a-zA-Z0-9-]+="[^"]*"/g, '')
        : this.html;

    navigator.clipboard.writeText(outerHTML || ``);

    this.tooaster.init({
      type: TOASTER_TYPE.INFO,
      content: `Copied element.`,
    });
  }
}
